export { default as ContextualHeader } from './ContextualHeader.vue';

export const SECTION_TYPES = {
	HERO: 'hero',
	CONTACT: 'contact',
	OVERVIEW: 'overview',
	MAP: 'map',
	EXCLUSIVITIES: 'exclusivities',
	CHARACTERISTICS: 'characteristics',
	SELL: 'sell',
	CONDO: 'condo',
	LOCATION: 'location'
} as const;

export type SectionType = (typeof SECTION_TYPES)[keyof typeof SECTION_TYPES];
